import { BaseHTMLAttributes } from 'react';
import { css } from '@emotion/react';
import cns from 'classnames';
import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';

export const BUTTON_GROUP_CLASSNAME = '__mapui_button_group';

const applyMainStyles =
  ({ isAttached }: Pick<ButtonGroupProps, 'isAttached'>) =>
  (theme) => {
    const defaultStyle = css(theme.buttonGroup.defaultStyles);

    const styles = [defaultStyle];

    if (isAttached) {
      styles.push(css(theme.buttonGroup.attached));
    } else {
      styles.push(css(theme.buttonGroup.notAttached));
    }

    return css(...styles);
  };

export interface ButtonGroupProps
  extends BaseHTMLAttributes<HTMLDivElement>,
    SpaceProps {
  isAttached?: boolean;
}

export const ButtonGroup = styled.div<ButtonGroupProps>(
  ({ theme, isAttached = false }) => ({
    ...applyMainStyles({ isAttached })(theme),
  }),
  ({ className }) => ({
    className: cns(BUTTON_GROUP_CLASSNAME, className),
  }),
  space
);
